<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { permissionManager } from "@/utils/permission";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      adminlist: [],
      adminsearch: "",
      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      userinfo: [],
      safeinfo: [],
      loading: true,
      block: false,
    };
  },
  mounted() {
    this.title = this.$t("menuitems.admin.text");
    this.items = [
      {
        text: this.$t("menuitems.admin.text"),
        active: true,
      },
    ];

    this.userinfo = JSON.parse(localStorage.getItem("user"));
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    this.fetchRolesFromApi().then(() => this.getadminlist());
  },
  methods: {
    fetchRolesFromApi() {
      if (!this.userinfo.openid || !this.apiuri) {
        return Promise.resolve();
      }
      return this.$axios
        .post(
          this.apiuri,
          { action: "getroles" },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((res) => {
          if (res.data && res.data.status === 200 && res.data.data) {
            permissionManager.applyServerRoles(res.data.data);
          }
        })
        .catch(() => {});
    },
    getadminlist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getadminuserlist",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data && response.data.data) {
            this.adminlist = response.data.data;
          } else {
            this.adminlist = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取管理员列表失败:", error);
          this.$message.error(this.$t("global.errors.network") || "网络错误");
        });
    },
    deleteadmin(id) {
      this.$confirm(
        this.$t("global.delete.deleteadmintip"),
        this.$t("global.delete.sureyouaction"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          cancelButtonText: this.$t("global.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$axios
            .post(
              this.apiuri,
              {
                action: "removeadminuser",
                id: id,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            )
            .then((response) => {
              this.loading = false;
              if (response.data && response.data.status == 200) {
                this.$message({
                  message: this.$t("global.delete.success"),
                  type: "success",
                });
              } else if (response.data && response.data.status == 403) {
                this.$message({
                  message: this.$t("global.delete.auth"),
                  type: "warning",
                });
              } else {
                this.$message.error(response.data?.msg || this.$t("global.delete.500"));
              }
              this.getadminlist();
            })
            .catch((error) => {
              this.loading = false;
              console.error("删除管理员失败:", error);
              this.$message.error(this.$t("global.errors.network") || "网络错误");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    getStatusCount(status) {
      return this.adminlist.filter(admin => admin.status === status).length;
    },
    resolveAdminRoleId(row) {
      if (!row) return 3;
      if (row.effective_role_id != null) return parseInt(row.effective_role_id, 10);
      if (row.roleid != null) return parseInt(row.roleid, 10);
      if (row.role_id != null) return parseInt(row.role_id, 10);
      return 3;
    },
    getPermissionLevelName(row) {
      const roleId = this.resolveAdminRoleId(row);
      if (row.role_name) {
        return row.role_name;
      }
      const hit = permissionManager
        .getAllRoles()
        .find((r) => r.id === roleId);
      if (hit && hit.name) {
        return hit.name;
      }
      const levels = {
        0: this.$t("permission.level.superAdmin"),
        1: this.$t("permission.level.admin"),
        2: this.$t("permission.level.operator"),
        3: this.$t("permission.level.viewer"),
        4: this.$t("permission.level.store"),
      };
      return levels[roleId] || this.$t("permission.level.unknown");
    },
    // 获取权限级别标签类型
    getPermissionLevelTagType(topuid) {
      const types = {
        0: 'danger',
        1: 'primary',
        2: 'warning',
        3: 'info',
        4: 'success'
      };
      return types[topuid] || 'info';
    },
    // 获取权限级别图标
    getPermissionLevelIcon(topuid) {
      const icons = {
        0: 'ri-shield-star-line',
        1: 'ri-shield-user-line',
        2: 'ri-user-settings-line',
        3: 'ri-eye-line',
        4: 'ri-store-2-line'
      };
      return icons[topuid] || 'ri-question-line';
    },
  },
  computed: {
    searchinadminlist() {
      var datas = this.adminlist;
      if (this.adminsearch) {
        datas = datas.filter((value) => {
          return (
            !this.adminsearch ||
            value.username
              .toLowerCase()
              .includes(this.adminsearch.trim().toLowerCase())
          );
        });
      }
      return datas;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <!-- 权限检查 -->
        <div v-if="!$hasPermission('admin.view')" class="card">
          <div class="card-body text-center">
            <el-result
              icon="error"
              :title="$t('global.error')"
              :subTitle="$t('global.text.nopermission')"
            >
              <template slot="extra">
                <el-button type="primary" size="medium" @click="$router.go(-1)">
                  {{ $t('global.button.back') }}
                </el-button>
              </template>
            </el-result>
          </div>
        </div>

        <!-- 主要内容 -->
        <div v-else>
          <!-- 统计信息卡片 -->
          <div class="row mb-4">
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card bg-primary text-white">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h6 class="card-title">{{ $t("admin.lists.total") }}</h6>
                      <h3 class="mb-0">{{ adminlist.length }}</h3>
                    </div>
                    <div class="align-self-center">
                      <i class="ri-user-line fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card bg-info text-white">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h6 class="card-title">{{ $t("permission.level.admin") }}</h6>
                      <h3 class="mb-0">{{ adminlist.filter(admin => resolveAdminRoleId(admin) === 1).length }}</h3>
                    </div>
                    <div class="align-self-center">
                      <i class="ri-shield-user-line fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card bg-warning text-white">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h6 class="card-title">{{ $t("permission.level.operator") }}</h6>
                      <h3 class="mb-0">{{ adminlist.filter(admin => resolveAdminRoleId(admin) === 2).length }}</h3>
                    </div>
                    <div class="align-self-center">
                      <i class="ri-user-settings-line fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card bg-secondary text-white">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h6 class="card-title">{{ $t("permission.level.viewer") }}</h6>
                      <h3 class="mb-0">{{ adminlist.filter(admin => resolveAdminRoleId(admin) === 3).length }}</h3>
                    </div>
                    <div class="align-self-center">
                      <i class="ri-eye-line fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 操作和搜索区域 -->
          <div class="card mb-4">
            <div class="card-header bg-light">
              <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-12 mb-2 mb-lg-0">
                  <h5 class="card-title mb-0">
                    <i class="ri-admin-line me-2"></i>
                    {{ $t("admin.lists.title") }}
                  </h5>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                         <div class="d-flex justify-content-end">
                           <router-link 
                             :to="{ path: '/admin/add' }" 
                             class="btn btn-success me-2"
                             v-if="$hasPermission('admin.add')"
                           >
                             <i class="ri-user-add-line me-1"></i>
                             {{ $t("admin.add.text") }}
                           </router-link>
                         </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- 搜索框 -->
              <div class="row mb-3">
                <div class="col-lg-6 col-md-8 col-12">
                  <el-input
                    v-model="adminsearch"
                    :placeholder="$t('admin.lists.search')"
                    clearable
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="adminsearch = adminsearch"
                  ></el-input>
                </div>
                <div class="col-lg-6 col-md-4 col-12">
                  <div class="d-flex justify-content-end">
                    <span class="text-muted align-self-center">
                      {{ $t("admin.lists.showing") }} {{ searchinadminlist.length }} {{ $t("admin.lists.of") }} {{ adminlist.length }} {{ $t("admin.lists.results") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 管理员列表 -->
          <el-card class="box-card" v-loading="loading">
            <div slot="header" class="clearfix">
              <span>
                <i class="el-icon-user-solid"></i>
                {{ $t("admin.lists.title") }}
              </span>
              <div style="float: right;">
                <el-button
                  icon="el-icon-refresh"
                  @click="getadminlist"
                  :loading="loading"
                  circle
                  size="small"
                ></el-button>
              </div>
            </div>

            <!-- Element UI 表格 -->
            <el-table
              :data="searchinadminlist"
              border
              stripe
              style="width: 100%"
              :empty-text="$t('global.text.nodata') || '暂无数据'"
              show-overflow-tooltip
            >
              <el-table-column
                :label="$t('admin.lists.username')"
                min-width="200"
              >
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                    <div class="avatar-sm bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3">
                      <i class="ri-user-line"></i>
                    </div>
                    <div>
                      <div class="fw-bold">{{ scope.row.username }}</div>
                      <small class="text-muted">ID: {{ scope.row.id }}</small>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="phone"
                :label="$t('admin.lists.phone')"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="fw-bold">{{ scope.row.phone || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('permission.level.title')"
                min-width="140"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag 
                    :type="getPermissionLevelTagType(resolveAdminRoleId(scope.row))" 
                    size="small"
                    effect="light"
                  >
                    <i :class="getPermissionLevelIcon(resolveAdminRoleId(scope.row))" class="me-1"></i>
                    {{ getPermissionLevelName(scope.row) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('admin.lists.status')"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag 
                    v-if="scope.row.status == 0" 
                    type="success" 
                    size="small"
                  >
                    <i class="ri-check-line me-1"></i>
                    {{ $t("admin.lists.normal") }}
                  </el-tag>
                  <el-tag 
                    v-else-if="scope.row.status == 1" 
                    type="warning" 
                    size="small"
                  >
                    <i class="ri-alert-line me-1"></i>
                    {{ $t("admin.lists.limit") }}
                  </el-tag>
                  <el-tag 
                    v-else-if="scope.row.status == 2" 
                    type="danger" 
                    size="small"
                  >
                    <i class="ri-close-line me-1"></i>
                    {{ $t("admin.lists.disable") }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('device.lists.action')"
                min-width="180"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="{ path: '/admin/add', query: { id: scope.row.id } }"
                    v-if="$hasPermission('admin.edit')"
                  >
                    <el-button type="primary" size="mini" icon="el-icon-edit" round>
                      {{ $t("admin.lists.edit") }}
                    </el-button>
                  </router-link>
                  <el-popconfirm
                    @confirm="deleteadmin(scope.row.id)"
                    :title="$t('global.delete.deleteadmintip')"
                    v-if="$hasPermission('admin.delete')"
                  >
                    <el-button 
                      slot="reference" 
                      type="danger" 
                      size="mini"
                      icon="el-icon-delete"
                      round
                    >
                      {{ $t("device.lists.delete") }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>

          </el-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* 管理员列表页面样式优化 */
.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 0.5rem;
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background-color: #f8f9fa;
}

/* 统计卡片样式 */
.bg-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
}

.bg-success {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%) !important;
}

.bg-warning {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%) !important;
}

.bg-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
}

.bg-info {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%) !important;
}

.bg-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #545b62 100%) !important;
}

/* 头像样式 */
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
}

/* 表格样式 */
.table-responsive {
  border-radius: 0.5rem;
  overflow: hidden;
}

.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  padding: 1rem 0.75rem;
}

.table tbody tr {
  transition: all 0.2s ease;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.admin-row td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
}

/* 徽章样式 */
.badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
}

.bg-success {
  background-color: #28a745 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

/* 按钮组样式 */
.btn-group .btn {
  border-radius: 0.375rem;
  margin-right: 0.25rem;
}

.btn-group .btn:last-child {
  margin-right: 0;
}

/* 移动端卡片样式 */
.admin-cards {
  padding: 1rem;
}

.admin-card .card {
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.admin-card .card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.admin-card .card-body {
  padding: 1rem;
}

/* 搜索框样式 */
.input-group-text {
  background-color: #f8f9fa;
  border-color: #ced4da;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .card-body {
    padding: 0.75rem;
  }
  
  .table-responsive {
    font-size: 0.875rem;
  }
  
  .btn-group {
    flex-direction: column;
  }
  
  .btn-group .btn {
    margin-right: 0;
    margin-bottom: 0.25rem;
  }
  
  .btn-group .btn:last-child {
    margin-bottom: 0;
  }
}

/* 加载状态样式 */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.8);
}

/* 空状态样式 */
.el-empty {
  padding: 2rem 0;
}

/* 图标样式 */
.fs-1 {
  font-size: 2.5rem !important;
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.admin-row {
  animation: fadeInUp 0.3s ease-out;
}

.admin-card {
  animation: fadeInUp 0.3s ease-out;
}

/* 状态徽章动画 */
.badge {
  transition: all 0.2s ease;
}

.badge:hover {
  transform: scale(1.05);
}

/* 按钮悬停效果 */
.btn {
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);
}

/* 统计卡片悬停效果 */
.bg-primary:hover,
.bg-success:hover,
.bg-warning:hover,
.bg-danger:hover,
.bg-info:hover,
.bg-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* 权限标签样式 */
.el-tag {
  border-radius: 0.375rem;
  font-weight: 500;
}

.el-tag--danger {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.el-tag--primary {
  background-color: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
}

.el-tag--warning {
  background-color: #fffbeb;
  border-color: #fed7aa;
  color: #d97706;
}

.el-tag--info {
  background-color: #f0f9ff;
  border-color: #bae6fd;
  color: #0284c7;
}

/* 权限标签悬停效果 */
.el-tag:hover {
  transform: scale(1.05);
  transition: all 0.2s ease;
}
</style>